<template>
	<div class="name-card">
		<v-card ref="card" :color="color" :dark="dark" :img="cardBgImage">
			<v-card-media v-if="showTopNav">
				<v-layout row justify-space-between class="ma-0">
					<v-flex xs2>
						<v-icon color="pink">favorite</v-icon>
					</v-flex>
					<v-flex xs2 class="text-sm-right">
						<v-icon>more_vert</v-icon>
					</v-flex>
				</v-layout>
			</v-card-media>
			<v-card-text>
				<div class="layout ma-0" :class="computeCardLayout">
					<div class="flex" :class="computeTextAlgin">
						<h4 v-if="companyVision != null && companyVision !== ''" style="font-style: italic">{{ companyVision }}</h4>
						<div class="caption">
							{{ name }}<span v-if="jobTitle != null && jobTitle != ''">, {{ jobTitle }}</span>
						</div>
						<div class="caption">{{ email }}</div>
						<div v-if="isAdmin"><v-chip color="success" label small text-color="white">Admin</v-chip></div>
					</div>
				</div>
			</v-card-text>
			<v-progress-circular v-if="isLoading" :indeterminate="true" color="#fff"></v-progress-circular>
		</v-card>
	</div>
</template>

<script>
	export default {
		props: {
			name: {
				type: String,
				default: ''
			},
			avatar: {
				type: Object,
				default: null
			},
			jobTitle: {
				type: String,
				default: ''
			},
			tenantName: {
				type: String,
				default: ''
			},
			email: {
				type: String,
				default: ''
			},
			cardBgImage: {
				type: String
			},
			color: {
				type: String,
				default: ''
			},
			dark: {
				type: Boolean,
				default: false
			},
			bottomNav: {
				type: Boolean,
				default: false
			},
			topNav: {
				type: Boolean,
				default: false
			},
			mini: {
				type: Boolean,
				default: false
			},
			isAdmin: {
				type: Boolean,
				default: false
			},
			isLoading: {
				type: Boolean,
				default: false
			},
			companyVision: {
				type: String,
				required: false
			}
		},
		data: () => ({}),

		computed: {
			computeCardLayout() {
				return this.mini ? 'column' : 'column';
			},
			computeTextAlgin() {
				return this.mini ? 'text-sm-left' : 'text-sm-center';
			},
			computeAvatarSize() {
				return this.mini ? '48' : '96';
			},
			showAvatar() {
				return this.avatar !== null && this.avatar.src;
			},
			showBottomNav() {
				return this.mini === false && this.bottomNav;
			},
			showTopNav() {
				return this.mini === false && this.topNav;
			}
		},
		methods: {}
	};
</script>

<style scoped>
	.name-card .v-card {
		/* height:100px; */
	}
	.caption {
		font-weight: 200;
	}
	.subheading {
		font-weight: 500;
	}
</style>
